import React from 'react';
import { RocketIcon, WrenchIcon, GlobeIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { finalTools } from '../../data/content';
export function FinalCta() {
  return <>
      <section className="bg-steel-100 py-12 sm:py-16" aria-labelledby="final-title" data-id="element-146" data-mp="1snjar3elhvxh">
        <div className="mx-auto w-full max-w-2xl px-4 sm:px-6" data-id="element-147" data-mp="1eo1sz7zpvixm">
          <h2 id="final-title" className="flex flex-col items-center gap-2 text-center font-display text-[1.75rem] font-extrabold uppercase leading-[1.02] text-ink-900 sm:text-4xl" data-id="element-148" data-mp="1eqnyz36ylqdq">
            <RocketIcon className="h-8 w-8 text-gold-600" aria-hidden="true" data-id="element-149" data-mp="19oykfdkj2ukw" />
            Ready to stop looking like a handyman…
          </h2>
          <p className="mt-2 text-center font-display text-xl font-extrabold uppercase leading-tight text-gold-600 sm:text-2xl" data-id="element-150" data-mp="2z4oazs5flf4v">
            …and start operating like a professional service business?
          </p>

          <p className="mt-5 text-center text-[15px] leading-relaxed text-ink-700 sm:text-base" data-id="element-151" data-mp="27acop9ymjn1">
            In the next 7 days, you can begin installing the systems that make
            your business look more organized, more consistent, and more
            professional.
          </p>

          <p className="mt-6 text-center text-sm font-bold uppercase tracking-wide text-ink-600" data-id="element-152" data-mp="70d34ojfxcz0">
            You’ll have professional tools for:
          </p>
          <ul className="mt-3 grid grid-cols-2 gap-2" data-id="element-153" data-mp="3ah3k1ygk9afh">
            {finalTools.map(tool => <li key={tool} className="flex items-center justify-center rounded-lg bg-ink-950 px-2 py-3 text-center font-display text-xs font-extrabold uppercase leading-tight tracking-wide text-gold-400 sm:text-sm" data-id="element-154" data-mp="3ogusljob5ym3">
                {tool}
              </li>)}
          </ul>

          <div className="mt-6 space-y-1.5 text-center text-[15px] text-ink-700 sm:text-base" data-id="element-155" data-mp="yqhlkhnn3pxl">
            <p data-id="element-156" data-mp="3sihacxpqi2e4">Instead of creating everything from scratch…</p>
            <p className="font-semibold text-ink-900" data-id="element-157" data-mp="1c6edfzkzrtn">
              Start with a system that’s already organized for you.
            </p>
          </div>

          <div className="mt-7 rounded-2xl border-2 border-ink-950 bg-white p-4 sm:p-6" data-id="element-158" data-mp="5c6t71qle518">
            <p className="text-center font-display text-3xl font-extrabold leading-none text-ink-900 sm:text-4xl" data-id="element-159" data-mp="acl3kqfo1r2f">
              Only $27 USD
            </p>
            <div className="mt-4" data-id="element-160" data-mp="3dtbf1ku0owbi">
              <CTAButton label="Get the Premium Technician Kit™" sub="Instant Download · Lifetime Access · One-Time Payment · 7-Day Guarantee" data-id="element-161" data-mp="3dumkdp342c4q" />
            </div>
            <div className="mt-5" data-id="element-162" data-mp="3nl7g94reh2jy">
              <Countdown tone="light" data-id="element-163" data-mp="2q4s40xjl25fq" />
            </div>
            <div className="mt-5" data-id="element-164" data-mp="2q48n9k5o5n3a">
              <ScarcityBar tone="light" label="Limited promotional availability" data-id="element-165" data-mp="2v3bth7xdxzcu" />
            </div>
            <p className="mt-3 flex items-center justify-center gap-2 text-center text-xs font-semibold text-ink-600" data-id="element-166" data-mp="2nju6fkkxmrbj">
              <GlobeIcon className="h-4 w-4 shrink-0 text-gold-600" aria-hidden="true" data-id="element-167" data-mp="2ikpx8ty0ctl7" />
              Automatic currency conversion based on your location.
            </p>
          </div>
        </div>
      </section>

      <footer className="bg-ink-950 px-4 py-10 sm:px-6" data-id="element-168" data-mp="29j9pyv2hp7l7">
        <div className="mx-auto w-full max-w-2xl text-center" data-id="element-169" data-mp="24l87ab8z7aa9">
          <div className="flex items-center justify-center gap-2" data-id="element-170" data-mp="24mj75zzavxw3">
            <WrenchIcon className="h-5 w-5 text-gold-500" aria-hidden="true" data-id="element-171" data-mp="1ztgmyigey0sk" />
            <span className="font-display text-lg font-extrabold uppercase tracking-[0.1em] text-white" data-id="element-172" data-mp="1uuvlkfpfdb2j">
              Premium Technician Kit<span className="text-gold-500" data-id="element-173" data-mp="1pxn1uaomoyz6">™</span>
            </span>
          </div>
          <p className="mt-3 text-sm text-steel-300" data-id="element-174" data-mp="1lv0987k4va0x">
            Turn your appliance repair trade into a more professional customer
            experience.
          </p>
          <p className="mt-5 text-xs text-steel-500" data-id="element-175" data-mp="3gy582z0l34qw">
            © 2026 Pedro Talavera · Premium Technician Kit™ — All rights
            reserved.
          </p>
        </div>
        <div className="h-16" aria-hidden="true" data-id="element-176" data-mp="3l1l69zsaxd5p" />
      </footer>
    </>;
}